import { inject } from '@angular/core';
import {
    RouterStateSnapshot,
    ActivatedRouteSnapshot, ResolveFn
} from '@angular/router';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { Observable } from 'rxjs';

export const FeatureFlagResolver: ResolveFn<boolean> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
        const featureFlagService = inject(FeatureFlagService);
        return featureFlagService.receiveAllFlagsAsObservable();
    };
